import type { ProductRow, ProductVersion } from '../../../services/billing';

// One rendered line: a base product, or the header and versions spliced
// under it when it is expanded.
export type ProductTableRow =
    | { kind: 'product'; id: string; product: ProductRow }
    | { kind: 'versionsHeader'; id: string; product: ProductRow }
    | { kind: 'version'; id: string; product: ProductRow; version: ProductVersion };

/** Everything spliced in under an expanded product. Never activates a row. */
export function isSubRow(row: ProductTableRow): boolean {
    return row.kind !== 'product';
}

// Splices the expanded product's versions in right after it.
export function expandProductRows(
    products: readonly ProductRow[],
    expandedId: string | null
): ProductTableRow[] {
    return products.flatMap((product) => {
        const row: ProductTableRow = { kind: 'product', id: product.id, product };
        // Defensive: the API guarantees every product at least one version.
        if (product.id !== expandedId || product.versions.length === 0) return [row];
        return [
            row,
            { kind: 'versionsHeader', id: `${product.id}:versions-header`, product },
            ...product.versions.map((version): ProductTableRow => ({
                kind: 'version',
                id: `${product.id}:${version.id}`,
                product,
                version
            }))
        ];
    });
}
